
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  PS_Supplier_Qual_Docs_2_Result.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PS_Supplier_Qual_Docs_2_Result.ts

export class PS_Supplier_Qual_Docs_2_Result {

  // int RefDocId
  public RefDocId: number=0;

  // int? SupplierId
  public SupplierId?: number=null;

  // string Cod
  public Cod?: string=null;

  // int DocTypId
  public DocTypId: number=0;

  // string LblCod
  public LblCod?: string=null;

  // int? Duree
  public Duree?: number=null;

  // byte TopInputDat
  public TopInputDat: number=0;

  // string Informations
  public Informations?: string=null;

  // byte? VisibleSupplier
  public VisibleSupplier?: number=null;

  // byte? TopDatInputIsEcheance
  public TopDatInputIsEcheance?: number=null;

  // string ImportAction
  public ImportAction?: string=null;

  // string Screen
  public Screen?: string=null;

  // byte? TopInputDescription
  public TopInputDescription?: number=null;

  // int? DocId
  public DocId?: number=null;

  // string FullPath
  public FullPath?: string=null;

  // DateTime? DateExpi
  public DateExpi?: Date=null;

  // int? WfId
  public WfId?: number=null;

  // int? StatutId
  public StatutId?: number=null;

  // DateTime? DatStatut
  public DatStatut?: Date=null;

  // int? ParentStatutId
  public ParentStatutId?: number=null;

  // string UserStatut
  public UserStatut?: string=null;

  // string StatutCod
  public StatutCod?: string=null;

  // string StatutLib
  public StatutLib?: string=null;

  // byte? TopFic
  public TopFic?: number=null;

  // string Description
  public Description?: string=null;

  // int? DisplayRank
  public DisplayRank?: number=null;

  // byte? TopMultiple
  public TopMultiple?: number=null;

  // int TopExpire
  public TopExpire: number=0;

  // int TopDelete
  public TopDelete: number=0;

  // int AddEmptyRow
  public AddEmptyRow: number=0;

  // int CanDelete
  public CanDelete: number=0;

  // int CanArchive
  public CanArchive: number=0;

  // int CanUpload
  public CanUpload: number=0;

  // int IsLastOccurrence
  public IsLastOccurrence: number=0;

  // string DisplayedStatut
  public DisplayedStatut?: string=null;
}